import getInstancesReduxSelector from 'modules/redux/selectors/get-instances'
import { SUBSCRIPTIONS_PATH } from 'modules/training/modules/subscription/constants'
import { getDataPathReduxUtil } from '@gymaholic/packages'

const getSubscriptionsSelect = getInstancesReduxSelector(
  SUBSCRIPTIONS_PATH.DATA,
  getDataPathReduxUtil(SUBSCRIPTIONS_PATH.ALL)
)

export default getSubscriptionsSelect
